import React from 'react';
import { Center, Spinner, Box, BoxProps } from '@chakra-ui/react';
import { CardSpinner } from '../../../../../domain';

export interface WorkspaceLayoutLoaderProps extends BoxProps {}

export const WorkspaceLayoutLoader: React.FC<
    { children?: React.ReactNode | undefined } & WorkspaceLayoutLoaderProps
> = (props) => <CardSpinner />;
